/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharingPermissionPreset
 */
export interface SharingPermissionPreset {
    /**
     * 
     * @type {number}
     * @memberof SharingPermissionPreset
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowCreate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowWriteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowWriteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowProxyDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowOriginalDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowSharing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowDeleteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    allowDeleteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    showHistory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharingPermissionPreset
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPreset
     */
    _default?: boolean;
}

export function SharingPermissionPresetFromJSON(json: any): SharingPermissionPreset {
    return SharingPermissionPresetFromJSONTyped(json, false);
}

export function SharingPermissionPresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharingPermissionPreset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'allowRead': !exists(json, 'allow_read') ? undefined : json['allow_read'],
        'allowCreate': !exists(json, 'allow_create') ? undefined : json['allow_create'],
        'allowWriteFs': !exists(json, 'allow_write_fs') ? undefined : json['allow_write_fs'],
        'allowWriteDb': !exists(json, 'allow_write_db') ? undefined : json['allow_write_db'],
        'allowProxyDownload': !exists(json, 'allow_proxy_download') ? undefined : json['allow_proxy_download'],
        'allowOriginalDownload': !exists(json, 'allow_original_download') ? undefined : json['allow_original_download'],
        'allowUpload': !exists(json, 'allow_upload') ? undefined : json['allow_upload'],
        'allowSharing': !exists(json, 'allow_sharing') ? undefined : json['allow_sharing'],
        'allowDeleteFs': !exists(json, 'allow_delete_fs') ? undefined : json['allow_delete_fs'],
        'allowDeleteDb': !exists(json, 'allow_delete_db') ? undefined : json['allow_delete_db'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'name': json['name'],
        '_default': !exists(json, 'default') ? undefined : json['default'],
    };
}

export function SharingPermissionPresetToJSON(value?: SharingPermissionPreset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allow_read': value.allowRead,
        'allow_create': value.allowCreate,
        'allow_write_fs': value.allowWriteFs,
        'allow_write_db': value.allowWriteDb,
        'allow_proxy_download': value.allowProxyDownload,
        'allow_original_download': value.allowOriginalDownload,
        'allow_upload': value.allowUpload,
        'allow_sharing': value.allowSharing,
        'allow_delete_fs': value.allowDeleteFs,
        'allow_delete_db': value.allowDeleteDb,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_ai_metadata': value.showAiMetadata,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'name': value.name,
        'default': value._default,
    };
}


